import {
  Alert,
  Box,
  Container,
  Grid,
  Link,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { AnyAaaaRecord } from 'dns';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppSelector } from 'store/hooks';

function Step4() {
  const { control } = useFormContext();
  const providers: any = useAppSelector((state) => state.signin.insuranceProviders);

  const [selectedProvider, setSelectedProvider] = useState<string>('');
  const [selectedProviderDescription, setSelectedProviderDescription] = useState<string>('');

  useEffect(() => {
    if (selectedProvider && providers?.insurance?.length > 0) {
      const provider = providers.insurance.find((p: any) => p.name === selectedProvider);
      setSelectedProviderDescription(provider ? provider.description : '');
    }
  }, [selectedProvider, providers]);

  return (
    <Container component='main' maxWidth='sm' sx={{ maxWidth: '700px !important' }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h1' textAlign={'center'}>
            Who is your insurance provider?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Alert
            severity='info'
            sx={{
              mt: 0,
              fontSize: 14,
              alignItems: 'flex-start',
            }}
          >
            <Typography>
              Please select your insurance from the dropdown (PPO plans only, no HMO or Medicaid).
            </Typography>

            <ul
              style={{
                fontSize: '13px',
                marginTop: '0px',
                marginBottom: '0px',
              }}
            >
              <li style={{ margin: 0, padding: 0, lineHeight: 1 }}>
                If your insurance is not listed, click{' '}
                <Link
                  href='https://www.mindweal.com/insurance/'
                  target='_blank'
                  rel='noopener'
                  underline='hover'
                >
                  here
                </Link>{' '}
                to view our full list of accepted plans.
              </li>

              <li style={{ margin: 0, padding: 0, lineHeight: 1 }}>
                If your insurance is accepted but does not appear in the dropdown, select “Other”.
              </li>

              <li style={{ margin: 0, padding: 0, lineHeight: 1 }}>
                If your insurance is not accepted, select “Insurance Not Listed / Not Accepted”.
              </li>
            </ul>
          </Alert>
        </Grid>

        <Grid item xs={12}>
          <Controller
            control={control}
            name='insurance'
            rules={{ required: true }}
            render={({ field }: any) => (
              <TextField
                id='how-did-you-hear-about-mindweal?'
                select
                fullWidth
                placeholder='Select your insurance provider'
                // onChange={(data: any) => field.onChange(data)}
                onChange={(e) => {
                  field.onChange(e); // keep form working
                  setSelectedProvider(e.target.value);
                }}
                defaultValue='select_your_insurance_provider'
              >
                <MenuItem key={-1} value='select_your_insurance_provider' disabled>
                  Select your insurance provider
                </MenuItem>
                {providers.insurance.map((provider: any) => (
                  <MenuItem key={provider.name} value={provider.name}>
                    {provider.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        {selectedProviderDescription && (
          <Grid item xs={12}>
            <Alert severity='info' sx={{ fontSize: '14px' }}>
              <Box
                sx={{
                  '& b': { fontWeight: 600 },
                  lineHeight: 1.6,
                  fontSize: '13px',
                }}
                dangerouslySetInnerHTML={{ __html: selectedProviderDescription }}
              />
            </Alert>
          </Grid>
        )}
      </Grid>
    </Container>
  );
}

export default Step4;
